module.exports = __webpack_public_path__ + "img/img_article6_tv.e6fed983.png";